import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["show", "player", "playerWrap", "hide"];

  initialize() {
    this.boundPauseAudio = this.pauseAudio.bind(this);
  }

  pauseAudio(event) {
    console.log(event);
    document.querySelectorAll("audio").forEach((e) => {
      if (e != event.target) {
        e.pause();
      }
    });
  }

  connect() {
    document.addEventListener("play", this.boundPauseAudio, true);
  }

  disconnect() {
    document.removeEventListener("play", this.boundPauseAudio);
  }

  start(_event) {
    this.showTarget.classList.add("d-none");
    //  this.playerWrapTarget.classList.remove("d-none");
    this.playerTarget.play();
  }

  hide(_event) {
    this.showTarget.classList.remove("d-none");
    this.playerTarget.pause();
    // this.playerWrapTarget.classList.add("d-none");
  }
}
